import {isReactNativeWeb} from '@/utils/user_agent';
import {getSiteUrl} from './get_site_url';

export const getApiHost = () => {
    // return 'https://mike2.jam.tools';
    return getSiteUrl();

    if (isReactNativeWeb()) {
        // return 'http://jam.local:1337';
        // return 'https://mike2.jam.tools';
        const userAgent = navigator.userAgent;
        if (userAgent.includes('iPhone')) {
            return 'http://localhost:1337';
        } else {
            return 'http://10.0.2.2:1337';
        }
    }

    return getSiteUrl();
};
